import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

import List from '../../../generic/List';

/**
 * Shows a loading row for the snippets table while data is being fetched.
 */
const LoaderRow: VoidFunctionComponent = () => {
  return (
    <List.RowContainer>
      <List.Row>
        <ContentLoader width="100%" height="28px">
          <rect y="3" rx="3" ry="3" width="100%" height="24px" />
        </ContentLoader>
      </List.Row>
    </List.RowContainer>
  );
};

export default LoaderRow;
